/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert.alert-danger[_ngcontent-%COMP%]{background:#dd3c10;border:1px solid #dd3c10;color:#fff}"];
export { styles as styles };
